export * from './ArrowDUturnRightDownIcon';
export * from './ArrowDUturnRightDownIcon16Light';
export * from './ArrowDUturnRightDownIcon16Regular';
export * from './ArrowDUturnRightDownIcon16Solid';
export * from './ArrowDUturnRightDownIcon20Light';
export * from './ArrowDUturnRightDownIcon20Regular';
export * from './ArrowDUturnRightDownIcon20Solid';
export * from './ArrowDUturnRightDownIcon24Regular';
export * from './ArrowDUturnRightDownIcon24Solid';
export * from './ArrowDUturnRightDownIcon32Regular';
export * from './ArrowDUturnRightDownIcon64Regular';
